import { styled } from "styled-components";

export const IconContainer = styled.div<{
  $compact?: boolean;
}>`
  display: flex;
  gap: ${(props) => (props.$compact ? "12px" : "24px")};
  flex-wrap: wrap;
`;
